module.exports = __webpack_public_path__ + "static/media/ac2.402732b7.mp3";